<template>
  <ets-popup title="Fichero No Generado" v-if="display" @close="closePopup()" @accept="acceptPopup()">
    <p>
      Todavía no se ha generado el fichero. La generación puede tardar unos minutos, ¿desea generarlo?
    </p>
  </ets-popup>
</template>

<script>
export default {
  name: "PopupNotGenerated",
  props: {
    displayNotGenerate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    display: false
  }),
  methods: {
    closePopup() {
      this.display = false;
      this.$emit("display-not-generate", this.display);
    },
    acceptPopup() {
      this.$emit("generate-procedure", true);
    }
  },
  watch: {
    displayNotGenerate: {
      immediate: true,
      handler() {
        this.display = this.displayNotGenerate;
      }
    }
  }
};
</script>
